import { render } from "./Gallery.vue?vue&type=template&id=18b0df8f"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Goya/components/Product/Gallery.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18b0df8f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18b0df8f', __exports__)) {
    api.reload('18b0df8f', __exports__)
  }
  
  module.hot.accept("./Gallery.vue?vue&type=template&id=18b0df8f", () => {
    api.rerender('18b0df8f', render)
  })

}


export default __exports__